var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiPropertyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.998557C10 0.689182 9.85938 0.398557 9.61563 0.211057C9.37188 0.0235575 9.05625 -0.0451925 8.75625 0.0298075L3.13438 1.43606C2.46875 1.60168 2 2.20168 2 2.88918V13.9986H1C0.446875 13.9986 0 14.4454 0 14.9986C0 15.5517 0.446875 15.9986 1 15.9986H3H9H10V14.9986V0.998557ZM8 7.99856C8 8.55168 7.66563 8.99856 7.25 8.99856C6.83437 8.99856 6.5 8.55168 6.5 7.99856C6.5 7.44543 6.83437 6.99856 7.25 6.99856C7.66563 6.99856 8 7.44543 8 7.99856ZM11 3.99856H14V14.9986C14 15.5517 14.4469 15.9986 15 15.9986H17C17.5531 15.9986 18 15.5517 18 14.9986C18 14.4454 17.5531 13.9986 17 13.9986H16V3.99856C16 2.89543 15.1031 1.99856 14 1.99856H11V3.99856Z",
    fill: "#F7CFD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiPropertyIcon);
export default __webpack_public_path__ + "static/media/multi-property-icon.b71aa94b625a44ed9be2802ca095812c.svg";
export { ForwardRef as ReactComponent };